import { render, staticRenderFns } from "./QuestionListDialog.vue?vue&type=template&id=720582e8&scoped=true&"
import script from "./QuestionListDialog.vue?vue&type=script&lang=js&"
export * from "./QuestionListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720582e8",
  null
  
)

export default component.exports